// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';
import { getNavList } from '@/api/topNav';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navList: null
  },
  mutations: {
    SET_NAV_LIST(state, navList) {
      state.navList = navList;
    }
  },
  actions: {
    async fetchNavList({ commit }) {
      try {
        const res = await getNavList();
        if (res.code === 200) {
          commit('SET_NAV_LIST', res.data);
          localStorage.setItem("navList", JSON.stringify(res.data));
        } else {
          console.error('Failed to fetch nav list:', res); // 调试信息
        }
      } catch (error) {
        console.error('Error fetching nav list:', error); // 调试信息
      }
    }
  },
  getters: {
    navList: state => state.navList
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js